import {
  ListItemButton as MUIListItemButton,
  ListItemButtonProps,
} from '@mui/material';
export const ListItemButton = ({ ...props }: ListItemButtonProps) => (
  <MUIListItemButton {...props} />
);
